import CtaButtonGroup, { CtaType } from "../molecules/CtaButtonGroup";

export enum BillingCycleType {
  Month = "month",
  Year = "year",
}

export type ScheduleCallPropsType = {
  title: string;
  ctas: CtaType[];
};

const ScheduleCallSection = ({ title, ctas }: ScheduleCallPropsType) => {
  return (
    <div className="flex flex-col items-center gap-4 px-4">
      <div className="text-center text-title-20">{title} </div>

      <CtaButtonGroup ctas={ctas} fullWidthOnMobile={false} align="sm:center" />
    </div>
  );
};

export default ScheduleCallSection;
